import { render, staticRenderFns } from "./BudgetCPMItem.vue?vue&type=template&id=1607e802&scoped=true&"
import script from "./BudgetCPMItem.vue?vue&type=script&lang=js&"
export * from "./BudgetCPMItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1607e802",
  null
  
)

export default component.exports